import z from 'zod';
var validator = z.object({
    _type: z.literal('reference'),
    _ref: z.string(),
    _weak: z.boolean().optional()
});
export default {
    validator: validator
};

//# sourceMappingURL=sanityReference.js.map